import { render, staticRenderFns } from "./editPaxelMarketMainFeatures.vue?vue&type=template&id=34afc240&"
import script from "./editPaxelMarketMainFeatures.vue?vue&type=script&lang=js&"
export * from "./editPaxelMarketMainFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports